// src/stores/toastStore.js
import { create } from 'zustand'

const useToastStore = create((set) => ({
    toasts: [],
    addToast: (message, variant = 'info') =>
        set((state) => ({
            toasts: [...state.toasts, { message, variant }],
        })),
    removeToast: (index) =>
        set((state) => ({
            toasts: [],
        })),
}))

export default useToastStore
